//@ts-nocheck
import { useState } from "react";
import { StrapiMedia } from "@/components/shared/StrapiMedia";
import { getItemAssetVariant, getItemsFromPhase } from "@/utils/itemUtils";
import { RoomVariant } from "@/types/game";
import RoomItemCheckerRoomSelect from "@/components/dev/RoomItemChecker/RoomItemCheckerRoomSelect";
import { usePhases } from "@/state/cacheStoreHooks";

type Props = {
    className?: string;
};

const RoomItemChecker = ({ className }: Props) => {
    const phases = usePhases();
    const [selectedPhaseId, setSelectedPhaseId] = useState<string | null>(null);
    const [selectedVariant, setSelectedVariant] = useState<RoomVariant | null>(null);
    const [hiddenItemIds, setHiddenItemIds] = useState<string[]>([]);

    const handleRoomSelect = (phaseId: string, roomVariant: RoomVariant) => {
        setHiddenItemIds([]);
        setSelectedPhaseId(phaseId);
        setSelectedVariant(roomVariant);
    };

    const handleItemClick = (itemId: string) => {
        setHiddenItemIds((prevState) =>
            prevState.includes(itemId) ? prevState.filter((id) => id !== itemId) : [...prevState, itemId],
        );
    };

    if (!selectedPhaseId) {
        return <RoomItemCheckerRoomSelect onSelect={handleRoomSelect} />;
    }

    const phase = phases.find((phase) => phase.documentId === selectedPhaseId);
    if (!phase || !selectedVariant) {
        return <div className="p-4">Selected phase or room not found.</div>;
    }

    const allPhaseItems = getItemsFromPhase(phase);

    const room = selectedVariant === "a" ? phase.room_a : phase.room_b;
    if (!room) {
        return <div className="p-4">Selected room not found.</div>;
    }

    return (
        <div className="size-full relative grid grid-cols-2 p-4">
            <div className="flex items-center justify-center">
                <div className="relative h-4/5 aspect-[360/640]">
                    <StrapiMedia
                        image={room.image}
                        size="lg"
                        alt={room.name}
                        className="absolute  object-cover size-full"
                        priority
                    />
                    {allPhaseItems.map((item) => {
                        if (hiddenItemIds.includes(item.documentId)) {
                            return null;
                        }
                        const image = getItemAssetVariant(item, selectedVariant);

                        return (
                            <StrapiMedia
                                size="lg"
                                key={item.documentId}
                                image={image}
                                alt={room.name}
                                className="absolute inset-0 object-cover size-full"
                                priority
                            />
                        );
                    })}
                </div>
            </div>
            <div className="w-full px-8 bg-gray-500 grid grid-cols-2 pb-8 gap-4">
                <button
                    className=" w-full text-center col-span-2 bg-gray-600 text-white rounded-md py-4 cursor-pointer"
                    onClick={() => setSelectedVariant((prevState) => (prevState === "a" ? "b" : "a"))}
                >
                    {"A <-> B"}
                </button>
                {allPhaseItems
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((item) => {
                        return (
                            <button
                                key={item.documentId}
                                onClick={() => handleItemClick(item.documentId)}
                                className={`w-full text-center py-2 cursor-pointer text-gray-800 ${
                                    hiddenItemIds.includes(item.documentId)
                                        ? "bg-gray-200/50"
                                        : "bg-gray-200 hover:bg-gray-300"
                                } rounded-md`}
                            >
                                {item.name}
                            </button>
                        );
                    })}
                <button
                    className="w-full text-center col-span-2 bg-blue-400 text-white rounded-md py-4 cursor-pointer"
                    onClick={() => setSelectedPhaseId(null)}
                >
                    Phase ändern
                </button>
            </div>
        </div>
    );
};

export default RoomItemChecker;
